import React from "react";
import { Button } from "reactstrap";
import "./Style/FilterOptions.scss"; // Import custom styles
import CustomEllipsis from "../../Utils/CustomEllipsis"; // Utility for text truncation
import CustomReactTooltip from "../../Components/CustomReactTooltip"; // Custom tooltip component

// Props:
// - trendingKeyWords: Array of trending keyword strings
// - publishedDateOptions: Array of date filter options
// - onLastUpdatedChange: Callback when a published date filter is selected
// - filterByTypeoptions: Array of filter type options
// - filterByTypeFilter: Currently selected filter type
// - onFilterByTypeChange: Callback when a filter type is selected
const FilterOptions = ({
  trendingKeyWords = [],
  publishedDateOptions = [],
  dateFilter,
  onLastUpdatedChange = () => {},
  filterByTypeoptions = [],
  filterByTypeFilter,
  onFilterByTypeChange = () => {},
  setTrendingKeywordSearch,
  setSearchInput,
}) => {
  return (
    <div className="filter-options">
      {/* === TRENDING KEYWORDS SECTION === */}
      <div className="trending-keyword">
        <p className="section-title">TRENDING KEY WORDS</p>
        <div className="btn-trending">
          {trendingKeyWords
            .filter((label) => label.length >= 2)
            .map((label, idx) => {
              const truncated = CustomEllipsis(label, 15); // Truncate label if too long
              return (
                <div key={idx} style={{ display: "inline-block" }}>
                  {/* Display each keyword as a button label with tooltip */}
                  <label
                    key={idx}
                    type="button"
                    className="btn mr-2 mt-2 px-2 btn-sm custom-button fs-12 hover-trending"
                    data-for={`trending-keyword-tooltip-${truncated.fullText}`}
                    data-tip={truncated.fullText}
                    onClick={() => {
                      setTrendingKeywordSearch(label);
                      setSearchInput(label);
                    }}
                  >
                    {truncated.text}
                  </label>

                  {/* Tooltip for full keyword text */}
                  <CustomReactTooltip
                    id={`trending-keyword-tooltip-${truncated.fullText}`}
                    multiline={true}
                  />
                </div>
              );
            })}
        </div>
      </div>

      {/* === PUBLISHED DATE SECTION === */}
      <div className="published-date">
        <p className="section-title">PUBLISHED DATE</p>
        <div className="btn1">
          {publishedDateOptions.map((opt, idx) => (
            <Button
              key={idx}
              color="primary"
              outline={!dateFilter || dateFilter !== opt.value}
              className={`mr-2 mt-2 py-1 px-2 fs-12 ${
                dateFilter === opt.value ? "active" : ""
              }`}
              onClick={() => onLastUpdatedChange(opt)} // Trigger callback on click
            >
              {opt.label}
            </Button>
          ))}
        </div>
      </div>

      {/* === FILTER BY TYPE SECTION === */}
      <div className="filter-by-type">
        <p className="section-title">FILTER BY TYPE</p>
        <div className="checkbox mt-2">
          {filterByTypeoptions.map((filter, key) => (
            <label className="label" key={key}>
              <input
                type="checkbox"
                checked={filterByTypeFilter === filter.value} // Single-selection logic
                onChange={() => onFilterByTypeChange(filter)} // Update selected filter
              />
              {filter.label}
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FilterOptions;
